import { JAVA_SERVICE_ENDPOINTS, JavaAPI } from '@buildwise/libs/services';
import { InsightFilterType } from './PythonInsightsAPI';

type UpdateInsightSummaryPayload = any;

export type InsightSummaryPayload = {
  companyId: string;
  filters?: InsightFilterType[];
  groupBy: string;
  projectId?: string;
  includeBWInsights: boolean;
};

class InsightsAPI extends JavaAPI {
  public getInsights(payload: {
    companyId: string;
    filters?: InsightFilterType[];
    groupBy: string;
    includeBWInsights: boolean;
    projectId?: string;
  }) {
    return this.post(
      JAVA_SERVICE_ENDPOINTS.GET_INSIGHTS.replace(':companyId', payload.companyId),
      {
        companyId: payload.companyId,
        ...(payload.projectId && {
          projectId: payload.projectId,
        }),
        includeBWInsights: payload.includeBWInsights,
      },
      (config) => ({
        ...config,
        headers: {
          ...config.headers,
          filters: JSON.stringify(payload.filters),
          groupBy: payload.groupBy,
        },
      }),
    );
  }

  public getInsightsSummary(payload: InsightSummaryPayload) {
    return this.post(
      JAVA_SERVICE_ENDPOINTS.GET_INSIGHTS_SUMMARY.replace(':companyId', payload.companyId),
      {
        companyId: payload.companyId,
        ...(payload.projectId && {
          projectId: payload.projectId,
        }),
        includeBWInsights: payload.includeBWInsights,
      },
      (config) => ({
        ...config,
        headers: {
          ...config.headers,
          filters: JSON.stringify(payload.filters),
          groupBy: payload.groupBy,
        },
      }),
    );
  }

  public saveInsightSummary(companyId: string, payload: UpdateInsightSummaryPayload) {
    delete payload.RefArticleId;
    delete payload.articleInfo;
    delete payload.suggestionTypes;
    delete payload.suitablePhases;
    delete payload.insightTitle;
    delete payload.insightDescription;
    delete payload.nonProprietarySynopsis;
    delete payload.nonProprietaryTitle;
    delete payload.updatedAt;

    const formData = new FormData();
    formData.append('insight', JSON.stringify(payload));

    return this.put(
      JAVA_SERVICE_ENDPOINTS.UPDATE_INSIGHT_SUMMARY.replace(':companyId', companyId).replace(
        ':insightId',
        payload?.id || '',
      ),
      formData,
    );
  }
}

const insightsAPI = new InsightsAPI();
export default insightsAPI;
